import Awesomplete from 'awesomplete';

export default function () {
  document.addEventListener('alpine:init', () => {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll('.type-ahead').forEach(input => {
        new Awesomplete(input, {
          autoFirst: true,
          replace: function (text: string) {
            this.input.value = text;
            this.input.dispatchEvent(new Event('input'));
          }
        });
      });
    });
  });
}
